// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./LinkTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- new DS implementation in progress */

.Link-module__Container__e4yWE {
    display: inline-flex;
    font-size: inherit;
    line-height: inherit;
    transition: var(--ds-transition-xs) ease-in;

    &:hover {
        text-decoration: none;
        cursor: pointer;
    }

    &:focus-visible {
        border-radius: var(--ds-border-radius-xs);
        outline: var(--ds-link-color-outline) solid var(--ds-border-width-focus);
    }
}

.Link-module__Icon__RBcGx {
    vertical-align: middle;
}

.Link-module__Standard__cPg1_ {
    gap: var(--ds-gap-xs);
    color: var(--ds-link-standard-color);
    text-decoration: underline;

    &:hover {
        color: var(--ds-link-standard-hover-color);
    }

    &:active {
        color: var(--ds-link-standard-active-color);
        text-decoration: none;
    }

    &:focus-visible {
        outline-offset: var(--ds-xs);
    }
}

.Link-module__Subtle__GHp_a {
    gap: var(--ds-gap-s);
    align-items: center;
    color: var(--ds-link-subtle-color);
    font-weight: var(--ds-font-weight-bold);
    font-size: var(--ds-text-small);

    &:hover {
        color: var(--ds-link-subtle-hover-color);
    }

    &:active {
        color: var(--ds-link-subtle-active-color);
        text-decoration: none;
    }
}

.Link-module__FullWidth__zNdzr {
    flex: 1;
    width: 100%;
}

.Link-module__InheritFontStyles__ROqv6 {
    color: inherit;
    font-size: inherit;
}

.Link-module__InheritFontStyles__ROqv6:hover {
    color: inherit;
    font-size: inherit;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Link-module__Container__e4yWE`,
	"Icon": `Link-module__Icon__RBcGx`,
	"Standard": `Link-module__Standard__cPg1_`,
	"Subtle": `Link-module__Subtle__GHp_a`,
	"FullWidth": `Link-module__FullWidth__zNdzr`,
	"InheritFontStyles": `Link-module__InheritFontStyles__ROqv6`
};
export default ___CSS_LOADER_EXPORT___;
